export function isIE(navigator: Navigator) {
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    return navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1
}
